<template>
  <header class="flex items-center justify-between">
    <figure role="img" aria-label="Freedom Travel logo">
      <a :href="mainPageLink" data-qa-id="main-page-logo-link">
        <img
          src="../assets/freedom-travel-minimal.svg"
          width="160"
          height="48"
          alt="freedom-travel.kz"
        />
      </a>
    </figure>
    <CashbackBadge @click="$emit('onOpenCashbackInfoModal')" />
  </header>
</template>

<script lang="ts" setup>
  import { NavigationLib } from '@shared/lib';
  import { injectAppContext } from '@shared/app-context';
  import { CashbackBadge } from '@entities/freedom-cashback';

  const { locale } = injectAppContext();
  const mainPageLink = NavigationLib.buildURL({ locale, path: '' });

  defineEmits<{
    onOpenCashbackInfoModal: [];
  }>();
</script>
